import React from "react";

const Heading = ({ title, extra }) => {
  return (
    <div className="heading-style ">
      <span
        style={{ fontWeight: "700", fontSize: "16px", lineHeight: "25px" }}
        className="d-flex"
      >
        {title} {extra}
      </span>
      <hr className="divider" style={{ margin: "10px 0" }} />
    </div>
  );
};

export default Heading;
